import { userSession } from "@src/session/UserSession";

export class GatewayAdminApi {
  public static async isAdmin(): Promise<boolean> {
    const { data } = await userSession.axiosInstance.get<boolean>("/admin");

    return data;
  }
}
